import React, { useState, useEffect } from 'react';
import { userAppData } from '../MainApp.js';
import { accessBoolean } from '../func.js';
import './QuickLinks.css';
import { MdComputer } from 'react-icons/md';
import { IoDocuments } from 'react-icons/io5';
import { useNavigate } from "react-router-dom";


import { OnCallAddNewCallFormModal } from '../common/modals.js';
import { FaBell } from 'react-icons/fa';

export default function QuickLinks() {
    const [onCallModalActiveState, setOnCallModalActiveState] = useState(false);

    const oncallLink = accessBoolean(userAppData['onCall']['perms']);
    const itLink = accessBoolean(userAppData['itRequestsData']['perms']);
    const reproLink = accessBoolean(Number(userAppData['reproRequestsData']?.perms ?? 0));

    let navigate = useNavigate();

    function modalClose() {
        setOnCallModalActiveState(false);
    };

    function newOnCallButtonClicked() {
        if (onCallModalActiveState) {
            setOnCallModalActiveState(false);
        } else {
            setOnCallModalActiveState(true);
        }
    }

    function newItButtonClicked() {
        navigate("/app/ItSupport/form");
    }

    // Opens the same Reprographics request form exposed through the sidebar.
    function newReproButtonClicked() {
        navigate("/app/repro/form");
    }

    return (
        <div className='QuickLinks_main_div'>

            <OnCallAddNewCallFormModal modalActiveState={onCallModalActiveState} setStateFunction={setOnCallModalActiveState} onModalClose={modalClose} />
            <h1 className='dashboard_tabHeaders'>Quick Links</h1>

            {oncallLink && (
                <div onClick={() => newOnCallButtonClicked()} className='QuickLinks_LinkDiv'>

                    <FaBell color='#ffffff' size={50} />
                    <p className='QuickLinks_LinkText'>New Oncall Request</p>

                </div>)}

            {itLink && (
                <div onClick={() => newItButtonClicked()} className='QuickLinks_LinkDiv'>

                    <MdComputer color='#ffffff' size={50} />
                    <p className='QuickLinks_LinkText'>New IT Request</p>

                </div>)}

            {reproLink && (
                <div onClick={() => newReproButtonClicked()} className='QuickLinks_LinkDiv'>

                    <IoDocuments color='#ffffff' size={50} />
                    <p className='QuickLinks_LinkText'>New Reprographics Request</p>

                </div>)}



        </div>
    )
};
